/* global angular */

require('angular-file-upload')
require('../../service/is-uploading.dataservice.js')
var logErrorToBackendService = require('aem-libs-angularjs/src/services/log-error-to-backend.service').logErrorToBackendService

angular.module('inputPrilohaCmp', ['angularFileUpload', 'UploadingDataserviceCmp'])
  .factory('logErrorToBackendService', logErrorToBackendService)
  .component('inputPriloha', {
    template: require('./input-priloha.component.tpl.html'),
    controller: InputPrilohaCtrl,
    controllerAs: 'vm',
    bindings: {
      formField: '<',
      value: '=',
      attachmentNames: '='
    }
  })

InputPrilohaCtrl.$inject = ['uniformsService', 'isUploadingDataservice', 'logErrorToBackendService']

function InputPrilohaCtrl (uniformsService, isUploadingDataservice, logErrorToBackendService) {
  var vm = this
  vm.$onInit = function () {
    vm.attachment = uniformsService.getAttachment()
    vm.fileName = (vm.attachmentNames && vm.attachmentNames[vm.value[vm.formField.id]]) || ''
    vm.MAX_BACKEND_FILESIZE = 7000
    vm.MAX_FILENAMELENGTH = 50
    vm.showSpinnerUpload = false
    vm.disabledInputFile = false
    isUploadingDataservice.reset(vm.formField.id)

    // CALLBACKS
    vm.attachment.onAfterAddingFile = function (fileItem) {
      fileItem.headers['Content-Disposition'] = 'attachment filename="' + encodeURIComponent(fileItem.file.name) + '"'
      vm.fileName = fileItem.file.name
      if (fileItem.file.name.length > vm.MAX_FILENAMELENGTH) {
        vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('attachment_maxFileNameLengthExceeded', false)
      } else {
        vm.disabledInputFile = true
        fileItem.upload()
        vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('attachment_invalidExtension', true)
        vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('attachment_maxSizeExceeded', true)
        vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('attachment_maxFileNameLengthExceeded', true)
      }
    }
    vm.attachment.onBeforeUploadItem = function (item) {
      vm.showSpinnerUpload = true
      isUploadingDataservice.set(vm.formField.id)
    }
    vm.attachment.onSuccessItem = function (fileItem, response, status, headers) {
      vm.showSpinnerUpload = false
      vm.disabledInputFile = false
      isUploadingDataservice.reset(vm.formField.id)

      if (response.status === 'ERR') {
        if (response.messages) {
          switch (response.messages[0]) {
            case 'attachment.invalidExtension':
              vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('attachment_invalidExtension', false)
              break

            case 'attachment.maxSizeExceeded':
              vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('attachment_maxSizeExceeded', false)
              break

            case 'attachment.maxFileNameLengthExceeded':
              vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('attachment_maxFileNameLengthExceeded', false)
              break

            default:
              vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('invalidDefault', false)
          }
        }
      }
    }
    vm.attachment.onErrorItem = function (fileItem, response, status, headers) {
      vm.showSpinnerUpload = false
      vm.disabledInputFile = false
      if (status === 400) {
        if (response.error && response.error.message === 'attachment.maxFileNameLengthExceeded') {
          vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('attachment_maxFileNameLengthExceeded', false)
        } else {
          vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('attachment_invalidExtension', false)
        }
      } else if (status === 0) {
        vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('attachment_maxTimeExceeded', false)
      } else {
        vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('invalidDefault', false)
      }

      logErrorToBackendService.error(JSON.stringify({
        status: status,
        fileItem: {
          file: fileItem.file,
          headers: fileItem.headers,
          url: fileItem.url,
          method: fileItem.method
        },
        response: response
      }))
    }
    vm.attachment.onCancelItem = function (fileItem, response, status, headers) {
      vm.showSpinnerUpload = false
      vm.disabledInputFile = false
    }
    vm.attachment.onCompleteItem = function (fileItem, response, status, headers) {
      vm.value[vm.formField.id] = response.id
      if (vm.attachmentNames) {
        vm.attachmentNames[response.id] = fileItem.file.name
      }
    }
    vm.attachment.onCompleteAll = function () {
      vm.showSpinnerUpload = false
      vm.disabledInputFile = false
      isUploadingDataservice.reset(vm.formField.id)
    }
  }
}
